module.exports = __webpack_public_path__ + "static/img/logo112.33827e6.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo112.png
// module id = r5ED
// module chunks = 1